import React from 'react';
import CheckListToneEnum from '../Enums/CheckListToneEnum';

const toneIcons = {
  [CheckListToneEnum.Ok]: 'fa-solid fa-circle-check',
  [CheckListToneEnum.Info]: 'fa-solid fa-circle-info',
  [CheckListToneEnum.Warn]: 'fa-solid fa-triangle-exclamation',
};

// Points to look at, one row each, in a bordered list: an icon for the kind of point, then its text. items are
// { tone, text }; tone is a CheckListToneEnum value, Info by default, and text may be an element. The icon carries
// the meaning, so it shows whatever the "I like icons" setting says.
export default function CheckList({ items = [] }) {
  return (
    <div className='check-list'>
      {items.map((item, index) => {
        const tone = item.tone ?? CheckListToneEnum.Info;
        return (
          <div
            key={index}
            className={`check-item ${tone}`}
          >
            <i
              className={toneIcons[tone]}
              aria-hidden='true'
            />
            <div>{item.text}</div>
          </div>
        );
      })}
    </div>
  );
}
